import Request, { Methods } from '@libraries/request/'
import ModelHero from '@models/hero'

export default class Vote extends Request {
  constructor(options) {
    super()
    this.hero = options.heroId
    this.voteKey = options.voteKey
  }

  get path() {
    return '/apis/vote'
  }

  get method() {
    return Methods.post
  }

  get parameters() {
    const params = {}
    params.hero_id = this.hero
    params.vote_key = this.voteKey
    return params
  }

  decode({ data }) {
    return new ModelHero(data)
  }

  decodeError(error) {
    return { 
      error: error,
    }
  }
}
